import React, { useEffect, useRef } from 'react';

const VideoPlayer = ({ stream, userName }) => {
  const videoRef = useRef(null);

  useEffect(() => {
    if (videoRef.current && stream) {
      videoRef.current.srcObject = stream;
    }
  }, [stream]);

  return (
    <div className="video-wrapper">
      <video
        ref={videoRef}
        autoPlay
        playsInline
      />
      <div className="user-name">{userName}</div>
    </div>
  );
};

export default VideoPlayer;
